









































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Moment from "moment-timezone";
import "@/assets/css/table.css";
import PageRequest from "@/store/entities/page-request";
import SearchTree from "@/lib/Common/searchtree";
import ShowInfo from './showdeviceinfo.vue';

/**
 * 分页数据
 */
class PageListRequest extends PageRequest {
    /**区域 */
    areaId: number;
    /**在线状态 */
    lineState: number;
    /**表计级别 */
    meterLevel: number;
}

@Component({
    components: { ShowInfo },
})

export default class CollectorMonitor extends AbpBase {
    /**搜索条件及分布 */
    pagerequest: PageListRequest = new PageListRequest();
    /**左侧区域树 */
    areaTree: any[] = [];
    /**左侧区域树 */
    areaTreeList: any[] = [];
    /**列表搜索名称 */
    searchName: string = "";
    /**设备列表 */
    devicelist: any[] = [];
    /**图片地址 */
    url: string = "@/assets/img/inline.png";
    /**分割 */
    splitnum: number = 0.15;
    /**设备级别 */
    levelist: any[] = [];
    /**状态列表 */
    statelist: any[] = [];
    /**总数据 */
    totalCount: number = 0;
    /**设备Id */
    deviceId: string = "";
    /**设备类型 */
    deviceType: number = 0;
    /**显示信息窗体 */
    showinfoModalShow: boolean = false;
    /**窗体新建 */
    async created() {
        await this.getAreaTree();
        this.getItemDetail();
        this.pagerequest.meterLevel = 0;
        this.pagerequest.lineState = 0;
        this.$store.state.meterinfo.pagesize = 50;
        await this.getData();
    }
    /**数据字典明细 */
    getItemDetail() {
        if (localStorage.getItem("itemdetail") === null) {
            this.$store.dispatch({
                type: "itemdetail/getdetailtolocalstorge",
            });
        }
        let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
        if (detaillist.length > 0) {
            let leve = detaillist.filter((p) => {
                return p.itemId == 9;
            });
            this.levelist = [];
            this.levelist.push({ label: this.L('All'), value: 0 })
            leve.forEach((ele) => {
                this.levelist.push({
                    label: ele.name,
                    value: ele.id,
                });
            });
        }
        this.statelist = [];
        this.statelist.push({ label: this.L('All'), value: 0 })
        this.statelist.push({ label: this.L('InLine'), value: 1 });
        this.statelist.push({ label: this.L('OffLine'), value: 2 });
    }
    /**选择区域触发 */
    async getAreaId() {
        let item = (this.$refs.tree as any).getSelectedNodes();
        if (item.length > 0) {
            this.pagerequest.areaId = item[0].id;
        }
        this.$store.commit("collectorinfo/setCurrentPage", 1);
        await this.getData();
    }
    /**搜索树形结构 */
    searchTree(value: any, treeList) {
        if (!value) {
            this.areaTree = this.areaTreeList;
            return;
        }
        this.areaTree = SearchTree.searnchTree(value, treeList);
    }
    /**区域 */
    async getAreaTree() {
        await this.$store
            .dispatch("area/getAreaLeftTree")
            .then((val) => {
                this.areaTree = val;
                this.areaTreeList = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    /**获取数据 */
    async getData() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        await this.$store
            .dispatch({ type: "collectorinfo/deviceMonitor", data: this.pagerequest })
            .then((val) => {
                if (val.status === 200) {
                    this.totalCount = val.data.result.totalCount;
                    this.devicelist = val.data.result.items;
                } else {
                    this.$Modal.error({
                        title: this.L("Tips"),
                        content: val.data.statusText,
                    });
                }

            })
            .catch((err) => {
                console.log(err);
            });
    }
    /**每页数量修改 */
    pageChange(page: number) {
        this.$store.commit("collectorinfo/setCurrentPage", page);
        this.getData();
    }
    /**页码修改 */
    pagesizeChange(pagesize: number) {
        this.$store.commit("collectorinfo/setPageSize", pagesize);
        this.getData();
    }
    /**每页条数 */
    get pageSize() {
        return this.$store.state.collectorinfo.pageSize;
    }
    /**页数 */
    get currentPage() {
        return this.$store.state.collectorinfo.currentPage;
    }
    /**显示设备信息 */
    showmeterinfo(deviceId: string, deviceType: number) {
        this.deviceId = deviceId;
        this.deviceType = deviceType;
        this.showinfoModalShow = true;
    }
    /**
    * 初始数据
    */
    data() {
        return {
            pageSizeOpts: [10, 20, 50, 100, 200],
        };
    }
}
